// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1K1zd","col":"styles_col__3HZT6"};